<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
        <v-layout wrap>
          <v-flex xs12 style="padding-left: 10px">
            <c-textbox v-model="hiddenFields['lstAccountId']" label="Danh sách Account"/>
          </v-flex>
        </v-layout>
        <c-search-form :input-search-items="searchItems"
                       :form-name="formName"
                       :hiddenFields="hiddenFields"
                       model="searchForm" :fields="fields"
                       key-property="logId"
                       :search-url="searchUrl"
                       :accept-create="false"
                       :accept-delete="false"
                       :acceptExport="1"
                       :reload="reload"
                       form-type="intable"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";
import {message} from "@/shared/message";
import {promises as fs} from "fs";
import CTextbox from "@/components/form/Textbox";

export default {
  name: 'log-management',
  components: {CTextbox, CSearchForm},
  data: () => {
    return {
      formName: "Lesson BabiClass",
      searchUrl: null,
      reload: 0,

      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'accountId',
          text: 'Account Id',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'profileId',
          text: 'Profile Id',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phone',
          text: 'Số điện thoại',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'countSumLessonAndLive',
          text: 'Số bài học hoàn thành (Lesson + Live)',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countSumLessonAndLiveContainWeek0',
          text: 'Tổng số bài học đã hoàn thành (lesson + Live + Week 0)',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countSumLessonWeek0',
          text: 'Số Lesson Week 0 hoàn thành',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countLesson',
          text: 'Số Lesson Hoàn thành (Không tinh W0)',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'countLive',
          text: 'Số Live Hoàn thành',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        }
      ],
      hiddenFields: {
        lstAccountId: "",
        fromDate: null,
        toDate: null,
      },
    }
  },
  methods: {
    onChangeFromDate(date) {
      this.hiddenFields.startDate = date;
      this.reload = Math.random()
    },
    onChangeToDate(date) {
      this.hiddenFields.endDate = date;
      this.reload = Math.random()
    },
    clearFromDate() {
      this.hiddenFields.startDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.endDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },
  created() {
    this.searchUrl = "/babiAccountClass/searchLessonBabiClass?sortField=status,classId&";
  }

}
</script>
